module.exports = "<div class=\"padding text-grey text-align\">\n\t<i class=\"fal fa-circle-notch fa-spin fa-2x\"></i>\n</div>"